import { ScheduleSlotsDay } from '@/app/(main)/(pages)/_components/schedules/_utils/group-slots-by-date';
import { isSchedulePast } from '@/utils/schedule/is-schedule-past.util';

export function dropPastScheduledSlots(days: ScheduleSlotsDay[], now?: Date): ScheduleSlotsDay[] {
  return days
    .map((day) => ({ ...day, slots: day.slots.filter((slot) => !isSchedulePast(slot.start, now)) }))
    .filter((day) => day.slots.length > 0);
}
